<!-- <button mat-raised-button #tooltip="matTooltip"  -->
  <button type="button" #tooltip="matTooltip"
    class="tooltip-btn"
    (click)="tooltip.toggle()"
    matTooltip= "{{message}}"
    matTooltipPosition="{{translateService.currentLang == 'ar' ? 'left':'right'}}">
    <fa-icon class="menu-icon iconDetails" [ngStyle]="{ 'color': iconColor != undefined ? iconColor : 'grey'}" [icon]="faInfo"></fa-icon>
</button>
